import React, { useEffect, useState } from "react";

const App = () => {
  const [display, setDisplay] = useState(false);
  const [, setInstallPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      if (event.isTrusted) {
        event.preventDefault(); // Prevent the default prompt

        // Store the event for later use
        setInstallPrompt(event);
        setDisplay(true); // Show the install prompt
      }
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  // const handleInstall = () => {
  //   if (installPrompt) {
  //     installPrompt.prompt(); // Show the install prompt
  //     installPrompt.userChoice.then((choiceResult) => {
  //       // The user has made a choice
  //       if (choiceResult.outcome === "accepted") {
  //         console.log("User accepted the install prompt");
  //       } else {
  //         console.log("User dismissed the install prompt");
  //       }

  //       setInstallPrompt(null); // Reset the install prompt
  //       setDisplay(false); // Hide the install prompt
  //     });
  //   }
  // };

  return (
    <div>
      {display && (
        <a
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40px",
            marginBlock: "20px",
            backgroundColor: "#7B36EE",
            color: "#fff",
          }}
          href="https://pubmining.org/assets/Pubmining.apk"
          download
        >
          Download app
        </a>
      )}
    </div>
  );
};

export default App;
